import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './CtaBanner.css';

function CtaBanner() {
  useStyles(s);

  return (
    <section className={s.cta}>
      <div className={s.inner}>
        <div className={s.left}>
          <h2 className={s.title}>Best food delivery service overall</h2>
          <p className={s.text}>
            Retail food delivery is a courier service in which a restaurant,
            store, or independent food delivery company delivers food to your
            door.
          </p>
        </div>
        <a href="https://linktr.ee/DOWNLOADASAP" className={s.btnPrimary}>
          Explore delivery
        </a>
      </div>
    </section>
  );
}

export default CtaBanner;
